// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"3d6b4273","164":"5d70150a","254":"f7297a9e","301":"4270c27b","444":"c51e2114","453":"4c31a81a"}[chunkId] + ".chunk.js";
};